import { ResponsiveBar } from '@nivo/bar';
import { nivoTheme } from '@shared/ui/nivoTheme';

// Digital tempo — Meta vs Google ad presence per month, as a Nivo grouped bar.
// Lazy-loaded (Nivo stays on-demand). Meta/Google keep their semantic brand colours.

const META = '#a06bff';
const GOOGLE = '#f0b84a';

export default function DigitalTempoNivo({ data }: { data: { month: string; Meta: number; Google: number }[] }) {
  const chip = (c: string, label: string) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
      <span style={{ width: 9, height: 9, borderRadius: 2, background: c, display: 'inline-block' }} />{label}
    </span>
  );
  return (
    <div>
      <div style={{ height: 140 }}>
        <ResponsiveBar
          data={data}
          keys={['Meta', 'Google']}
          indexBy="month"
          groupMode="grouped"
          colors={[META, GOOGLE]}
          borderRadius={3}
          padding={0.32}
          innerPadding={2}
          margin={{ top: 10, right: 8, bottom: 22, left: 28 }}
          axisLeft={{ tickSize: 0, tickPadding: 6, tickValues: 4 }}
          axisBottom={{ tickSize: 0, tickPadding: 6 }}
          enableGridX={false}
          enableLabel={false}
          theme={nivoTheme}
          defs={[
            { id: 'gm', type: 'linearGradient', x1: 0, y1: 0, x2: 0, y2: 1, colors: [{ offset: 0, color: META, opacity: 0.95 }, { offset: 100, color: META, opacity: 0.4 }] },
            { id: 'gg', type: 'linearGradient', x1: 0, y1: 0, x2: 0, y2: 1, colors: [{ offset: 0, color: GOOGLE, opacity: 0.95 }, { offset: 100, color: GOOGLE, opacity: 0.4 }] },
          ]}
          fill={[{ match: { id: 'Meta' }, id: 'gm' }, { match: { id: 'Google' }, id: 'gg' }]}
          animate
          role="img"
          ariaLabel="Meta vs Google ad presence per month"
        />
      </div>
      <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#8a94a6', marginTop: 2 }}>
        {chip(META, 'Meta')}{chip(GOOGLE, 'Google')}
      </div>
    </div>
  );
}
